import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ToastModule} from 'primeng/toast';
import { MessageService } from 'primeng/api';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import {CardModule} from 'primeng/card';
import {TableModule} from 'primeng/table';
import {PanelModule} from 'primeng/panel';
import {SidebarModule} from 'primeng/sidebar';
import {ButtonModule} from 'primeng/button';
import {OrganizationChartModule} from 'primeng/organizationchart';
import {TabViewModule} from 'primeng/tabview';
import {TreeModule} from 'primeng/tree';
import {ProgressBarModule} from 'primeng/progressbar';
import {DragDropModule} from 'primeng/dragdrop';
import {FileUploadModule} from 'primeng/fileupload';
import {FullCalendarModule} from '@fullcalendar/angular';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { MenuModule } from 'primeng/menu';
import { SpeedDialModule } from 'primeng/speeddial';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { BadgeModule } from 'primeng/badge';
import { ListboxModule } from 'primeng/listbox';
import { PickListModule } from 'primeng/picklist';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AccordionModule } from 'primeng/accordion';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputNumberModule } from 'primeng/inputnumber';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { TagModule } from 'primeng/tag';
import { StepsModule } from 'primeng/steps';

const modules=[
  DropdownModule,
  CheckboxModule,
  ScrollPanelModule,
  ProgressSpinnerModule,
  TagModule,
  ToastModule,
  DialogModule,
  ConfirmDialogModule,  
  CardModule,
  TableModule,
  PanelModule,
  SidebarModule,
  ButtonModule,
  OrganizationChartModule,
  TabViewModule,
  TreeModule,
  DragDropModule,
  FileUploadModule,
  ProgressBarModule,
  TieredMenuModule,
  BreadcrumbModule,
  FullCalendarModule,
  SpeedDialModule,
  MenuModule,
  OverlayPanelModule,
  BadgeModule,
  ListboxModule,
  PickListModule,
  RadioButtonModule,
  AccordionModule,
  InputSwitchModule,
  InputNumberModule,
  AutoCompleteModule,
  StepsModule,
  CalendarModule
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    modules
  ],
  exports:[
    modules
  ],
  providers:[
    MessageService,
    ConfirmationService
  ]
})
export class PrimengModule { }
